import React from 'react';
import cn from 'classnames';

import AgreementCheckbox from './AgreementCheckbox/AgreementCheckbox';

import { AgreementCheckboxType, useAgreementCheckboxWrapper } from './AgreementCheckboxWrapper.hook';

import { useTheme, EngineTheme, useMergeClasses } from '../../theme';

export interface AgreementCheckboxChildrenProps {
	isValid: boolean;
	scrollToCheckboxes: () => void;
}

interface Props {
	className?: string;
	classes?: EngineTheme['AgreementCheckboxWrapper']['AgreementCheckboxWrapper'];
	children: (props: AgreementCheckboxChildrenProps) => React.ReactNode;
	showTooltip?: boolean;
	checkboxes: AgreementCheckboxType[];
	renderButton?: (props: AgreementCheckboxChildrenProps) => React.ReactNode;
}

const AgreementCheckboxWrapper: React.FunctionComponent<Props> = ({
	className,
	classes,
	showTooltip,
	children,
	checkboxes: initialCheckboxes,
	renderButton
}) => {
	const { AgreementCheckboxWrapper: defaultClasses } = useTheme('AgreementCheckboxWrapper');

	const css = useMergeClasses(defaultClasses, classes);

	const {
		checkboxesRef,
		isValid,

		checkedCheckboxes,

		onChange,
		scrollToCheckboxes
	} = useAgreementCheckboxWrapper(initialCheckboxes);

	return (
		<>
			{children({ isValid, scrollToCheckboxes })}

			<div className={css.footer_wrapper}>
				<div className={cn(css.checkboxes_wrapper, className)} ref={checkboxesRef}>
					{!!checkedCheckboxes.length &&
						checkedCheckboxes.map(item => (
							<AgreementCheckbox
								key={item.fieldName}
								{...item}
								showTooltip={showTooltip}
								onChange={onChange}
							/>
						))}
				</div>

				{!!renderButton && renderButton({ isValid, scrollToCheckboxes })}
			</div>
		</>
	);
};

export default AgreementCheckboxWrapper;
